/* [Modified by Codex at 2026-10-12] FAQ 使用独立延后脚本和区块内事件，避免内联阻塞与重载后重复绑定。 */
(() => {
  if (customElements.get('faq-accordion')) return;

  class FaqAccordion extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      const title = event.target.closest?.('.bls__page-faq-items > .bls__page-faq-title');
      if (!title || title.closest('faq-accordion') !== this) return;
      const item = title.parentElement;
      const content = item.querySelector('.bls__page-faq-content');
      if (!content) return;
      event.preventDefault();
      if (content.getAnimations?.().length) return;
      const wasOpen = getComputedStyle(content).display !== 'none';

      if (typeof slideAnime === 'function') {
        slideAnime({ target: content, animeType: 'slideToggle' });
        // 只有动画被接收或显示状态已变化时更新图标，避免快速点击或其他区块动画造成状态错位。
        const changed = (getComputedStyle(content).display !== 'none') !== wasOpen;
        if (!content.getAnimations || content.getAnimations().length || changed) {
          item.classList.toggle('active', !wasOpen);
        }
      } else {
        // 主题主脚本尚未就绪时，首次点击也能正常展开或收起。
        content.style.display = wasOpen ? 'none' : 'block';
        item.classList.toggle('active', !wasOpen);
      }
    }
  }

  customElements.define('faq-accordion', FaqAccordion);
})();
/* [End] */
